import { createElement, styled, composedProps } from '@vebox/etui-system';

const SvgElement = createElement('svg');
const Svg = styled(SvgElement)(composedProps);

export { Svg };
